(function () {
    'use strict';

    angular.module('app.audit', [
        'app.core',
        'ngAnimate'       
    ]);
})();
